import ApiPingService from '../../services/ApiPingService';
import apiPingUseCase from './PingUseCase';

const apiPingFactory = apiPingUseCase({ ApiPingService: ApiPingService() });

export default apiPingFactory;
